import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

/**
 * What is waiting for this member of staff, polled.
 *
 * ── WHY IT IS ITS OWN FILE ──────────────────────────────────────────────────
 *
 * Both the bell and the console's menu read it: the bell says HOW MUCH is
 * waiting, the badges say WHERE. React Query dedupes by key, so they are one
 * request and the number beside "Support" can never disagree with the number
 * in the bell — two separate queries would be two requests and up to an
 * interval apart.
 *
 * It lived in `InboxBell.tsx` first, which cost that file its Fast Refresh:
 * React cannot hot-swap a module that exports both a component and something
 * else, and losing it on the admin layout means losing it on every console
 * screen. Same reason `iconPaths` is separate from `Icon`.
 */
export function useInbox() {
  return useQuery({
    queryKey: ['admin', 'inbox'],
    queryFn: ({ signal }) => api.adminInbox(signal),
    // Twenty seconds — the same cadence as the buyer's bell. A minute is a
    // long time to leave somebody sitting in a chat window.
    refetchInterval: 20_000,
    // Nobody is looking at a backgrounded tab, and a console left open
    // overnight should not spend the night counting.
    refetchIntervalInBackground: false,
    // The moment they come back, though, which is what actually happens.
    refetchOnWindowFocus: true,
    staleTime: 10_000,
  });
}
